<template>
  <component :is="isRouter ? 'router-link' : 'button'" :to="to" class="rounded-[5px] bg-black text-white inline-block font-regular font-text text-body-m px-4 py-2 transition-all hover:bg-blue-500"
  >
    <slot />
  </component>
</template>

<script>
export default {
  props: ['to'],

  computed: {
    isRouter() {
      return typeof this.to !== 'undefined' && this.to.length > 0;
    },
  }
}
</script>
